
/**
  * Do not change! File was auto generate.
  *
  */
import { ReactElement, SVGProps } from 'react';
import { ReactComponent as Part3EarlyYearsIconComponent } from "./part3-early-years-icon.svg";

export const Part3EarlyYearsIcon = (props: SVGProps<SVGSVGElement>): ReactElement => {
  return <Part3EarlyYearsIconComponent {...props} />;
};
